import * as React from 'react';
import { PropsWithChildren, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import Sidebar from 'features/sidebar';
import Header from 'features/header';

const WIDTH_SIDEBAR = 280;
const ProtectedLayout: React.FC<PropsWithChildren> = (props) => {
  const [openSidebar, setOpenSidebar] = useState<boolean>(true);

  const onToggleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  return (
    <Box bgcolor="#F4F4F4" height="100vh" position="relative">
      <Header onToggleSideBar={onToggleSidebar} />
      <Sidebar openSidebar={openSidebar} width={WIDTH_SIDEBAR} />
      <Grid
        position="absolute"
        top={64}
        left={openSidebar ? WIDTH_SIDEBAR : 0}
        right={0}
        bottom={0}
        overflow="auto"
      >
        {props.children ?? <Outlet />}
      </Grid>
    </Box>
  );
};

export default ProtectedLayout;
